import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { variant } from 'styled-system';

const ButtonAction = styled('button')(
  {
    backgroundColor: '#35b9b6', //#menta
    color: 'white',
    fontWeight: 'bold',
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
  variant({
    variants: {
      extra: {
        width: '284px',
        height: '48px',
        borderRadius: '31px',
        fontSize: '20px',
        '&:hover': {
          backgroundColor: '#1daeab',
        },
      },
      secondary: {
        width: '256px',
        height: '40px',
        borderRadius: '20px',
        fontSize: '16px',
        '&:hover': {
          backgroundColor: '#1daeab',
        },
      },
      tertiary: {
        width: 200,
        height: 40,
        borderRadius: 20,
        '&:hover': {
          backgroundColor: '#1daeab',
        }
      },
    },
  })
);

const Button = props => (
  <ThemeProvider theme={{}}>
    <ButtonAction {...props}>{props.children}</ButtonAction>
  </ThemeProvider>
);

export default Button;
